import { Config } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import { BulkCreateItem, Relationship, GroupDelegate } from '@leverege/molten/imagine';
export default {
  id: 'blueprint.action.paymentsAtBilling.BulkCreateItem',
  name: 'Bulk Create Payments',
  matches: {
    client: 'GroupScreen',
    use: ['contextMenu'],
    path: 'bill'
  },
  handles: cxt => {
    const {
      clientProps: {
        actions: pActions
      }
    } = cxt;
    const relationship = Relationship.getByPath('payment');
    const actions = new GroupDelegate({
      relationship: relationship.createResolved(pActions.match),
      match: pActions.match,
      queryName: 'payment.search'
    });
    const can = actions?.canCreate();
    return can === true;
  },
  layout: {
    sort: 'payment.add2',
    sectionName: 'Payment Actions'
  },
  appearance: () => {
    return {
      name: 'Bulk Create Payments',
      icon: Config.get('BlueprintActions', 'bulkCreateIcon', 'https://storage.googleapis.com/molten-ui-assets/bulk-create-action.png')
    };
  },
  perform: ({
    context
  }) => {
    const {
      clientProps: {
        actions: pActions
      }
    } = context;
    const relationship = Relationship.getByPath('payment');
    const delegate = new GroupDelegate({
      relationship: relationship.createResolved(pActions.match),
      match: pActions.match,
      queryName: 'payment.search'
    });
    Dialogs.show({
      component: BulkCreateItem,
      props: {
        delegate,
        relationship
      }
    });
  }
};